/*
 * @Author: vicshang
 * @Date: 2020-08-19 10:29:29
 * @Last Modified by: vicshang
 * @Last Modified time: 2020-09-14 09:24:18
 * 自定义表单Card
 */
<template>
  <Card class="clearfix">
    <p slot="title" v-if="title">{{title}}</p>
    <Form :label-position="labelWidth ? 'right': 'top'" v-if="mode == 'detail'" :rules="fieldsRules" :label-width="labelWidth" :ref="formRef" key='custom-form1'>
      <Row :gutter="16" v-for="(row, index) in fields" :key="index" >
        <Col :xs="24" :sm="12" :md="item.span" v-for="(item, indexKey) in row" :key="indexKey">
          <FormItem :label="item.label + '：'" v-if="item.type=='image'">
            <img-upload v-model="item.value" :keyVal="item.imgKey" :edit="false" />
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='select'">
            <span>{{item.options[model[item.key]].name}}{{item.suffix ? item.suffix: ''}}</span>
          </FormItem>
          <FormItem :label="item.label + '：'" v-else>
            <span>{{model[item.key]}}{{item.suffix ? item.suffix: ''}}</span>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Form :label-position="labelWidth ? 'right': 'top'" v-if="mode == 'edit' || mode == 'add'" :model="model" :rules="fieldsRules" :label-width="labelWidth" :ref="formRef" key='custom-form2'>
      <Row :gutter="16" v-for="(row, index) in fields" :key="index" >
        <Col :xs="24" :sm="12" :md="item.span" v-for="(item, indexKey) in row" :key="indexKey">
          <FormItem :label="item.label + '：'" v-if="item.type=='input'" :prop="item.key">
            <Input v-model.trim="model[item.key]" :placeholder="item.placeholder ? item.placeholder : '请填写' + item.label" >
              <span slot="append" v-if="item.suffix">{{item.suffix ? item.suffix: ''}}</span>
            </Input>
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='textarea'" :prop="item.key" >
            <Input v-model.trim="model[item.key]" type="textarea" :maxlength="800" :placeholder="item.placeholder ? item.placeholder : '请填写' + item.label"></Input>
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='select'" :prop="item.key" >
            <select class="selectYk selectW" v-model="model[item.key]">
              <option value>---请选择---</option>
              <option v-for="option in item.options" :value="option.value" :key="option.value">{{option.name }}</option>
            </select>
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='date'" :prop="item.key">
            <Date-picker type="date" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" class="selectW" v-model="model[item.key]"></Date-picker>
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='radio'" :prop="item.key">
            <RadioGroup v-model="model[item.key]">
              <Radio :value="option.value" v-for="option in item.options" :key="option.value">{{option.name}}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem :label="item.label + '：'" v-if="item.type=='image'">
            <img-upload v-model="model[item.key]" :keyVal="item.imgKey" :type="2" :edit="item.edit ? true : false" />
          </FormItem>
          <!-- <FormItem :label="item.label + '：'" v-if="item.type=='image'" :prop="item.key">
            <img-upload v-model="model[item.key]" :keyVal="item.imgKey" :edit="item.edit ? true : false" />
          </FormItem> -->
        </Col>
      </Row>
    </Form>
  </Card>
</template>
<script>
import ImgUpload from '../img-upload';
import uniqueId from 'lodash/uniqueId';
export default {
  name: 'CustomForm',
  components: {
    ImgUpload
  },
  props: {
    formsRef: {
      type: Array,
      required: true
    },
    title: { // Card 的标题
      type: String,
      default: ''
    },
    dataArr: { // 字段数据
      type: Array,
      default: [],
      required: true
    },
    defaultSpan: { // 默认每个字段占多少格，基于bootsrtap栅格（24）
      type: Number,
      default: 6
    },
    mode: { // 模式（edit【编辑状态】、detail【查看详情状态】）
      type: String,
      default: 'edit'
    },
    model: { // 数据模型
      type: Object,
      default: {},
      required: true
    },
    labelWidth: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      fields: [],
      fieldsRules: {},
      formRef: `form-${uniqueId()}`,
      preComponent: null
    };
  },
  mounted () {
    this.initFields(); // 初始化字段
  },
  watch: { // 监听字段
    dataArr () {
      this.initFields();
    },
    mode () {
      this.initFields();
    }
  },
  updated () {
    // 由于initFields会操作data数据，所以每次updated都会被触发
    if (this.formsRef && Object.prototype.toString.call(this.formsRef) === '[object Array]' && this.mode != 'detail') {
      this.formsRef.splice(this.formsRef.indexOf(this.preComponent), 1); // 删除之前的ref
      this.formsRef.push(this.$refs[this.formRef]);
      this.preComponent = this.$refs[this.formRef]; // 保存上一个组件引用
    }
  },
  methods: {
    initFields () { // 初始化字段方法
      const { dataArr, defaultSpan, getVerifyRules } = this;
      const spanNum = 24;
      if (dataArr.length) {
        const fields = []; // 多维数组
        let row = [];
        let span = 0;
        for (let i = 0; i < dataArr.length; i++) {
          dataArr[i].type = dataArr[i] ? (dataArr[i].type || 'input') : 'input'; // 类型设置
          const itemSpan = (dataArr[i].type == 'image' || dataArr[i].type == 'textarea') ? spanNum : (dataArr[i] ? (dataArr[i].span || defaultSpan) : defaultSpan); // 单个字段所占栅格数
          dataArr[i].span = itemSpan; // 补全span属性
          dataArr[i].isShow = dataArr[i] ? (dataArr[i].isShow != undefined ? dataArr[i].isShow : true) : true; // 补全isShow 属性
          if (dataArr[i].isShow) {
            const { key, label, verify } = dataArr[i];
            verify && (this.fieldsRules[key] = getVerifyRules(verify, label)); // 存在验证规则，则放到fieldsRules中
            span += itemSpan;
            row.push(dataArr[i]);
            if (span >= spanNum) {
              fields.push(row);
              span = 0;
              row = [];
            } else {
              if ((i + 1) == dataArr.length) {
                fields.push(row);
              }
            }
          }
        }
        this.fields = fields;
      }
    },
    getVerifyRules (verify, label) {
      if (verify && Object.prototype.toString.call(verify) === '[object Array]' && label) {
        const len = verify.length;
        const verifyRules = [];
        for (let i = 0; i < len; i++) {
          const item = verify[i];
          if (item && item.required) {
            item.message = item.message ? item.message : `请填写${label}`; // 优化没有填写必填项的message
          }
          verifyRules.push(item);
        }
        return verifyRules;
      } else {
        return [];
      }
    }
  }
};
</script>
<style>
.selectW {
  width: 100%;
}
</style>
